
export class Messages {
    static login = {
        "failure": "Login failed. Please check your username and password and try again."
    }

    static endpoint = {
        "unsupportedVersion": "This endpoint does not support the currently selected version.",
        "activeVersions": "The active versions for this endpoint are",
        "activeVersion": "The active version for this endpoint is",

    }

    static snackbar = {
        "endpointUriCopied": {"severity": "success", "header": "Copied to Clipboard", "message": "Endpoint URI successfully copied to clipboard!"},
        "requestExampleCopied": {"severity": "success", "header": "Copied to Clipboard", "message": "Request Example successfully copied to clipboard!"},
        "responseExampleCopied": {"severity": "success", "header": "Copied to Clipboard", "message": "Response Example successfully copied to clipboard!"},
        "requestAccessSent": {"severity": "success", "header": "Request Sent", "message": "Your request has been submitted. Our team will reach out to you shortly to assist you with accessing our API Explorer."},
        "passwordResetSent": {"severity": "success", "header": "Password REcovery Email Sent", "message": "Your request has been submitted. An email will be sent to the address listed on your AndDone merchant account with further instructions."},
        "passwordResetFailure": {"severity": "alert", "header": "Missing Username", "message": "Please enter your AndDone Merchant username in the field below and submit your request again."},
        
    }
}
  